import { Injectable } from '@angular/core';
import { DynForm } from 'src/app/_model/dyn-form';
import { IMSObject, IMSObjectType } from 'src/app/_model/ims-object';
import { RemoteAction } from 'src/app/_model/remote-action/remote-action';

/**
 * Interface Definition for a PostProcessorService
 *
 * PostProcessorsService responsible for iterating over PostProcessors and active postprocessors found in dynform definition
 */
@Injectable()
export abstract class PostProcessorService {
  /**
   * Received DynFormData from dynforms to access post processors written in the document. If
   * there are none, skip this process and if post processor found, execute them based
   * on their parameters.
   *
   * @param data
   */
  public abstract handlePostProcessors(
    form: DynForm,
    formData: any,
    imsObject: IMSObject,
    remoteAction: RemoteAction,
  ): Promise<any>;
}
